import { createAction, props } from "@ngrx/store";
import { IReleaseNotes } from "../../models/release-notes";

const prefix = "[Release Notes Page]";

export const requestReleaseNotesPage = createAction(
  `${prefix} Request Release Notes By Page`,
  props<{ pageNum: number }>(),
);
export const requestTotalReleaseNotesCount = createAction(
  `${prefix} Request Total Release Notes Count`,
);
export const notesAddedSuccess = createAction(
  `${prefix} Release Notes Added`,
  props<{ notes: IReleaseNotes[] }>(),
);
export const countAddedSuccess = createAction(
  `${prefix} Release Note Count Added`,
  props<{ length: number }>(),
);
export const notesAddedError = createAction(`${prefix} Release Notes Error`);
export const countAddedError = createAction(
  `${prefix} Release Note Count Error`,
);
export const getReleaseNotesbyId = createAction(
  `${prefix} Get Release Notes by Id`,
  props<{ releaseNotesResponse: IReleaseNotes }>(),
);
export const selectReleaseNote = createAction(
  `${prefix} Select Release Note`,
  props<{ releaseNote: IReleaseNotes }>(),
);
export const clearSelectedReleaseNote = createAction(
  `${prefix} Clear Selected Release Note`,
);
